import { whypeConfig } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { ensureConfigTypes } from '@/domain/hooks/useWrite'
import { aaveDataLayerQueryKey } from '@/domain/market-info/aave-data-layer/query'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ActionConfig, ActionContext } from '@/features/actions/logic/types'
import { toBigInt } from '@/utils/bigNumber'
import { WrapAction } from '../types'

export function createWrapActionConfig(action: WrapAction, context: ActionContext): ActionConfig {
  const { account, chainId } = context
  return {
    getWriteConfig: () => {
      const value = toBigInt(action.token.toBaseUnit(action.value))
      const whypeContractAddress = getContractAddress(whypeConfig.address, chainId)

      return ensureConfigTypes({
        address: whypeContractAddress,
        account,
        abi: whypeConfig.abi,
        functionName: 'deposit',
        value,
      })
    },

    invalidates: () => [
      getBalancesQueryKeyPrefix({ chainId, account }),
      aaveDataLayerQueryKey({ chainId, account }),
      aaveDataLayerQueryKey({ chainId, account, refetchEnabled: true }),
    ],
  }
}
